export default {
  model: [
    {
      label: 'Login',
      field: 'login',
      type: 'text'
    },
    {
      label: 'Senha',
      field: 'password',
      type: 'text',
      password: true
    },
    {
      label: 'Confirmar senha',
      field: 'confirm_password',
      type: 'text'
    }
  ]
}